import { render, staticRenderFns } from "./BitacoraHistoryTab.vue?vue&type=template&id=698e4338"
import script from "./BitacoraHistoryTab.vue?vue&type=script&lang=js"
export * from "./BitacoraHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports